import { action } from "typesafe-actions";
import { City } from "@models/city";
import {RequestData} from "@models/axios";


export const enum CitiesActionTypes {
    FETCH_REQUEST = "@@cities/FETCH_REQUEST",
    FETCH_SUCCESS = "@@cities/FETCH_SUCCESS",
    FETCH_ERROR = "@@cities/FETCH_ERROR",

    DELETE_REQUEST = '@@cities/DELETE_REQUEST',
    DELETE_SUCCESS = '@@cities/DELETE_SUCCESS',
    DELETE_ERROR = '@@cities/DELETE_ERROR',

    CREATE_REQUEST = '@@cities/CREATE_REQUEST',
    CREATE_SUCCESS = '@@cities/CREATE_SUCCESS',
    CREATE_ERROR = '@@cities/CREATE_ERROR',

    UPDATE_REQUEST = '@@cities/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@cities/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@cities/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = "@@cities/FETCH_ITEM_REQUEST",
    FETCH_ITEM_SUCCESS = "@@cities/FETCH_ITEM_SUCCESS",
    FETCH_ITEM_ERROR = "@@cities/FETCH_ITEM_ERROR",
}

export const fetchRequest = (data: {}) => action(CitiesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: City[]) => action(CitiesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(CitiesActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(CitiesActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:RequestData) => action(CitiesActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(CitiesActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(CitiesActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data:RequestData) => action(CitiesActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(CitiesActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(CitiesActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data:RequestData) => action(CitiesActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(CitiesActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data: RequestData) => action(CitiesActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: City[]) => action(CitiesActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(CitiesActionTypes.FETCH_ITEM_ERROR, message);
